import * as React from 'react';
import Input from '../../../../Input/Input';
import { Datepicker } from '../../../../Datepicker';
import { Dialog } from '@mui/material';
import { DateMaskedInput } from '../../../../DateMaskedInput/DateMaskedInput';
const DateMaskedInputInner = React.forwardRef((props, ref) => (React.createElement(DateMaskedInput, Object.assign({}, props, { ref: ref, placeholder: "__.__.____", guide: false }))));
export const DateField = props => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Input, { label: props.label, value: props.value, name: props.name, className: props.className, labelClassName: props.labelClassName, labelShrinkClassName: props.labelShrinkClassName, focused: props.focused, TextFieldProps: {
                onChange: props.onChange,
                onBlur: props.onBlur,
                error: !!props.error,
                helperText: props.error,
                disabled: props.disabled,
                type: 'tel'
            }, shrink: props.shrink, variant: props.variant, inputComponent: DateMaskedInputInner, absoluteHintPosition: props.absoluteHintPosition }),
        !!props.datePicker && (React.createElement(Dialog, { open: props.datePicker.isOpenDatePicker, onClose: props.datePicker.onCloseDatePicker },
            React.createElement(Datepicker, { openDate: props.datePicker.openDate, selectedDates: props.datePicker.selectedDates, minDate: props.datePicker.minDate, maxDate: props.datePicker.maxDate, onSelect: props.datePicker.onSelect })))));
};
